module.exports = __webpack_public_path__ + "img/Louisiana outline.e6cff933.png";